<template>
    <HeaderContent title="Technician"/>
    <ActionContent ctaText="Add Technician" @action="showModal" @showFilter="modalFilter = !modalFilter" :filterDate="false" @search-query="searchData"/>
    <TechnicianStatistics title="Technician Statistics" :data="statistics" />
    <TechnicianForm :modal="modal" :technicianData="technician" @update:modal="updateModal" @addOrUpdate="getAll"/>
    <TechnicianFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event" @filter-data="searchData"/>
    <TechnicianConfirm title="Confirmation" :uuid="technicianUuid" @action="deleteData" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
        <template #text>Are you sure to delete this data ?</template>
    </TechnicianConfirm>
    <TechnicianDataTable :data="technicians" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import TechnicianForm from './TechnicianForm.vue';
import TechnicianFilter from './TechnicianFilter.vue';
import TechnicianDataTable from '@/components/DataTable.vue';
import TechnicianStatistics from '@/components/StatisticData.vue';
import TechnicianConfirm from '@/components/ModalDialog.vue';
import iconUserPlumber from '../../../public/icons/user-plumber.svg';
import { ref, inject, onMounted } from 'vue';

export default {
    components: {
        HeaderContent,
        ActionContent,
        TechnicianForm,
        TechnicianFilter,
        TechnicianDataTable,
        TechnicianStatistics,
        TechnicianConfirm,
    },
    setup() {
        const repositories = inject('repositories')
        const technicianRepository = repositories ? repositories.technician : null
        const modal = ref(false)
        const modalFilter = ref(false)
        const modalConfirm = ref(false)
        const technicianUuid = ref(null)
        const technician = ref({})
        const technicians = ref([])

        const headers = ref([
            {
                key: 'no',
                label: 'No'
            },
            {
                key: 'name',
                label: 'Name',
                sortable: true
            },
            {
                key: 'type',
                label: 'Type',
                sortable: true
            },
            {
                key: 'action',
                label: 'Actions'
            }
        ])

        const customActions = ref([
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                    getById(item.uuid)
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                    showConfirmModal(item.uuid)
                }
            },
        ])

        const statistics = ref([])

        const getAll = async () => {
            await technicianRepository.getAll().then((res) => {
                technicians.value = res.data.data
                statistics.value = [  
                    {
                        label: 'Total',
                        key: 'Technician',
                        value: res.data.data.length,
                        color: 'primary',
                        icon: iconUserPlumber,
                    }
                ]
            }).catch(err => {
                console.error(err)
            })
        }

        const getById = async (uuid) => {
            await technicianRepository.getById(uuid).then((res) => {
                technician.value = res.data.data
                modal.value = true
            }).catch(err => {
                console.error(err)
            })
        }

        const updateModal = (newValue) => {
            modal.value = newValue;
            technician.value  = {}
        }

        const showModal = () => {
            modal.value = true
        }

        const showConfirmModal = (uuid) => {
            modalConfirm.value = true
            technicianUuid.value = uuid
        }

        const deleteData = async (actionType, uuid) => {
            console.log(uuid)
            await technicianRepository.delete(uuid).then(() => {
                modalConfirm.value = false
                getAll()
            }).catch(err => {
                console.error(err)
            })
        }

        const searchData = async (keyword) => {
            await technicianRepository.search(keyword).then((res) => {
                technicians.value = res.data.data
            }).catch(err => {
                console.error(err)
            })
        }

        onMounted(() => {
            getAll()
        })

        return {
            modal,
            modalConfirm,
            technicianUuid,
            technician,
            technicians,
            headers,
            customActions,
            statistics,
            updateModal,
            showModal,
            showConfirmModal,
            deleteData,
            getAll,
            getById,
            searchData,
            modalFilter
        }
    }
}
</script>